import {Box,Typography} from '@mui/material';

const PageHeader=({title,actions})=>{
    return (
        <Box sx={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between','& > *':{m:1,},}}>
            <Typography variant="h6" style={{margin:'5px',marginBottom:'auto',fontSize:'1.15rem'}}>{title}</Typography>
            {actions&&<Box sx={{display:'flex',alignItems:'center',gap:1}}>{actions}</Box>}
        </Box>
    );
}

export default PageHeader;